import MpkConfigPage from './MpkConfigPage';

export default MpkConfigPage;
